const  qualitydata=[{
    id:1,
    images:"https://cdn-icons-png.flaticon.com/128/5726/5726647.png",
    heading:"Web App Testing",
    para:"We offer web application testing services to ensure quality, functionality, and security. Our experienced testers identify bugs, issues, and vulnerabilities."

},
{
    id:2,
    images:"https://cdn-icons-png.flaticon.com/128/3289/3289934.png",
    heading:"Mobile App Testing",
    para:"Our mobile app testers provide customizable testing services to identify bugs, issues, or vulnerabilities in your app, including performance, functional, and security testing."
},
{
    id:3,
    images:"https://cdn-icons-png.flaticon.com/512/5517/5517107.png",
    heading:"Client Server Application",
    para:"We offer client-server application development services, which includes design, development, testing, and maintenance to businesses of all sizes."
},
{
    id:4,
    images:"https://cdn-icons-png.flaticon.com/128/4488/4488414.png",
    heading:"Functional Testing",
    para:"We offer software functional testing services that thoroughly test applications to ensure they meet functional requirements and specifications."
},
{
    id:5,
    images:"https://cdn-icons-png.flaticon.com/128/6742/6742562.png",
    heading:"Compatibility Testing",
    para:"Our experienced testers will identify compatibility issues and ensure your software is compatible with your target audience's devices and platforms."
},
{
    id:6,
    images:"https://cdn-icons-png.flaticon.com/128/1779/1779374.png",
    heading:"Usability Testing",
    para:"We evaluate software applications' user experience and identify usability issues, providing recommendations for improvement."
},
{
    id:7,
    images:"https://cdn-icons-png.flaticon.com/128/7067/7067977.png",
    heading:"Performance Testing",
    para:"We test software performance under various conditions, identify issues, and provide improvement recommendations to meet audience requirements."
},
{
    id:8,
    images:"https://cdn-icons-png.flaticon.com/128/1085/1085710.png",
    heading:"Regression Testing",
    para:"Our experienced team performs thorough regression testing to ensure software applications function properly after any updates or changes, maintaining quality and functionality."
},
{
    id:9,
    images:"https://cdn-icons-png.flaticon.com/128/1781/1781791.png",
    heading:"Maintenance Testing",
    para:"We provide maintenance testing to ensure software applications continue to function properly after maintenance or updates, identifying any issues or performance degradation."
}
]
export default qualitydata;